import React, { CSSProperties, useMemo } from "react";
import { Avatar } from "@radix-ui/themes";
import { SvgRadius } from "../entities/ChatSettingsV2";
import { QuackLogo } from "../assets/QuackLogo";

interface WidgetSVGProps {
  path: string;
  iconSize: number;
  initials?: string;
  hide?: boolean;
  radius?: SvgRadius;
}

export function WidgetSVG({
  path,
  iconSize,
  initials,
  hide = false,
  radius,
}: WidgetSVGProps) {
  return (
    <Avatar
      color={"gray"}
      src={path}
      fallback={initials ?? <QuackLogo />}
      className={"qc-Chat__Custom_SVG"}
      radius={radius}
      style={
        {
          "--avatar-size": `${iconSize}px`,
          display: hide ? "none" : "flex",
        } as CSSProperties
      }
    />
  );
}

export interface MessageAvatarSVGProps {
  path?: string;
  kind?: "agent" | "user";
  initials?: string;
  radius?: SvgRadius;
  cssOverrides?: CSSProperties;
  alt?: string;
}

export function MessageAvatarSVG({
  path,
  kind,
  initials,
  radius,
  cssOverrides,
  alt,
}: MessageAvatarSVGProps) {
  const styles = useMemo<CSSProperties>(() => {
    if (kind === "agent") {
      return {
        "--accent-a11": "var(--agentText)",
        "--accent-a3": "var(--agentBackground)",
      } as CSSProperties;
    } else if (kind === "user") {
      return {
        "--accent-a11": "var(--userText)",
        "--accent-a3": "var(--userBackground)",
      } as CSSProperties;
    } else {
      return {};
    }
  }, [kind]);

  return (
    <Avatar
      size={"1"}
      color={"gray"}
      radius={radius}
      src={path}
      fallback={initials ?? <QuackLogo />}
      className={"qc-Chat__Custom_SVG"}
      style={{ ...styles, ...cssOverrides }}
      alt={alt}
    />
  );
}
